<template>
  <sidebar-menu
    :menu="filteredMenu"
    :collapsed="collapsed"
    @toggle-collapse="toggleSidebar"
    :width="sidebarWidth"
  >
    <template v-slot:header>
      <div class="text-center">
        <img
          v-if="!collapsed"
          style="width: 100%; max-width: 155px; padding-top: 20px"
          :src="require('@/assets/images/BeautyConnect_logo.png')"
          alt="logo"
        />
      </div>
      <div
        v-if="env.NODE_ENV !== 'production'"
        class="text-center"
        style="color: #fff; font-weight: bold; padding-top: 1rem"
      >
        UAT SITE
      </div>
      <div class="row" v-if="!collapsed">
        <div class="col mx-3 my-2">
          <label for="filterMenu" class="text-white pb-2">Search Menu</label>
          <div class="form-group has-search">
            <span class="form-control-feedback">
              <font-awesome-icon :icon="['fas', 'search']" />
            </span>
            <input
              v-model="searchKey"
              type="text"
              class="form-control"
              id="filterMenu"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer
      ><div
        class="d-flex align-items-center justify-content-center color-hover"
        style="color: white"
      >
        <a v-if="!collapsed" class="logout-btn" @click="logoutSession"
          ><font-awesome-icon
            class="logout-icon"
            :icon="['fas', 'sign-out-alt']"
          /><span>Logout</span>
        </a>
        <a
          v-else
          class="logout-btn"
          style="margin-left: 15px"
          @click="logoutSession"
          ><font-awesome-icon
            class="logout-icon"
            :icon="['fas', 'sign-out-alt']"
          />
        </a></div
    ></template>
    <span slot="toggle-icon"
      ><font-awesome-icon :icon="['fas', 'bars']"
    /></span>
  </sidebar-menu>
</template>

<script>
import {
  TokenService,
  PrivilegeStorageService,
  CrmTriggerStorageService,
  BookingStorageService,
  BookingCalendarStorageService,
} from "@/services/storage.service";
import listMenu from "./listMenu.json";
import { SidebarMenu } from "vue-sidebar-menu";

export default {
  components: {
    SidebarMenu,
  },
  data() {
    return {
      collapsed: true,
      SIDEBAR_WIDTH: 250,
      SIDEBAR_WIDTH_COLLAPSED: 50,
      menu: [],
      filteredMenu: [],
      isAdmin: null,
      isBA: null,
      isBC: null,
      isSalesSupervisor: null,
      env: process.env,
      searchKey: null,
    };
  },
  computed: {
    sidebarWidth() {
      return `${
        this.collapsed ? this.SIDEBAR_WIDTH_COLLAPSED : this.SIDEBAR_WIDTH
      }px`;
    },
  },
  mounted() {
    this.toggleSidebar();
    this.getUserRole();
  },
  methods: {
    toggleSidebar() {
      this.collapsed = !this.collapsed;
      this.$emit("sideBarWidth", this.sidebarWidth);
    },
    getMenu() {
      const isServiceReservationEnabled = process.env.VUE_APP_FEATURE_SERVICE_RESERVATION_ENABLED === 'true';
      const hiddenTitles = new Set(["Booking", "Service Master", "Booking Calendar"]);

      const clonedMenu = structuredClone(listMenu);

      this.menu = clonedMenu.map((s) => {
        let isHidden = true;

        if (!isServiceReservationEnabled && hiddenTitles.has(s.title)) {
          s.hidden = true;
          return s;
        }

        if (s.header) {
          return {
            ...s,
          };
        }

        if (s.child && Array.isArray(s.child)) {
          s.child = s.child.filter((c) => {

            if (!c.auth) return true;

            return c.auth.some((a) =>
                a === this.isAdmin ||
                a === this.isBA ||
                a === this.isBC ||
                a === this.isSalesSupervisor ||
                a === this.isShiseidoBA ||
                a === this.isCPBBA ||
                a === "ALL"
            );
          });
        }

        s.auth.forEach((a) => {
          if (a === this.isAdmin) {
            isHidden = false;
          }
          if (a === this.isBA) {
            isHidden = false;
          }
          if (a === this.isBC) {
            isHidden = false;
          }
          if (a === this.isSalesSupervisor) {
            isHidden = false;
          }
          if (a === this.isShiseidoBA) {
            isHidden = false;
          }
          if (a === this.isCPBBA) {
            isHidden = false;
          }
          if (a === "ALL") {
            isHidden = false;
          }
        });

        if (s.child && s.child.length === 0) {
          isHidden = true;
        }

        s.hidden = isHidden;
        return {
          ...s,
        };
      });
      this.filteredMenu = this.menu;
    },
    getUserRole() {
      const userBrand = JSON.parse(TokenService.getUserBrands());
      const userRole = JSON.parse(TokenService.getUserRoles());
      this.isAdmin = userRole.find((u) => u === "ROLE_ADMIN");
      this.isBA = userRole.find((u) => u === "ROLE_BRAND_ADMIN");
      this.isBC = userRole.find((u) => u === "ROLE_BC");
      this.isSalesSupervisor = userRole.find(
        (u) => u === "ROLE_SALES_SUPERVISOR"
      );
      if (
        userRole.includes((u) => u === "ROLE_BRAND_ADMIN") &&
        userBrand?.includes("SH")
      ) {
        this.isShiseidoBA = "ROLE_SH_BRAND_ADMIN";
      }
      if (
        userRole.includes((u) => u === "ROLE_BRAND_ADMIN") &&
        userBrand?.includes("CP")
      ) {
        this.isCPBBA = "ROLE_CPB_BRAND_ADMIN";
      }
      this.getMenu();
    },
    clearRelevantStorage() {
      console.log("Clearing storage...");
      PrivilegeStorageService.removeStoredParams();
      PrivilegeStorageService.removeStoredBrand();
    },
    logoutSession() {
      TokenService.removeToken();
      TokenService.removeUserRoles();
      TokenService.removeRefreshToken();
      TokenService.removeUserBrands();
      PrivilegeStorageService.removeStoredBrand();
      PrivilegeStorageService.removeStoredParams();
      CrmTriggerStorageService.removeStoredBrand();
      CrmTriggerStorageService.removeStoredTriggerType();
      CrmTriggerStorageService.removeStoredStatus();
      CrmTriggerStorageService.removeStoredStartDateFrom();
      CrmTriggerStorageService.removeStoredStartDateTo();
      CrmTriggerStorageService.removeStoredParams();
      CrmTriggerStorageService.removeCreateTriggerType();
      BookingStorageService.removeStoredParams();
      BookingStorageService.removeStoredCurrentPage();
      BookingCalendarStorageService.removeStoredParams();
      this.$router.push({ name: "Login" });
    },
    isIncludeSearchKey(title) {
      return title?.toLowerCase().includes(this.searchKey.toLowerCase());
    },
  },
  watch: {
    $route(to, from) {
      const isChildRoute =
        to.path.startsWith(from.path) || from.path.startsWith(to.path);

      if (!isChildRoute && from.path !== to.path) {
        this.clearRelevantStorage();
      }
    },
    searchKey() {
      this.filteredMenu = this.menu.filter((m) => {
        return (
          this.isIncludeSearchKey(m.title) ||
          m?.child?.some((c) => this.isIncludeSearchKey(c.title))
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .vsm--header {
  text-align: center;
}

::v-deep .vsm--icon {
  background-color: transparent !important;
}

.vsm--icon .svg-inline--fa .fa-key .fa-w-16 {
  width: 15px;
  height: 15px;
}

.logout-btn {
  margin: 1rem 0;
  text-decoration: none;
  color: white;
  font-size: 1.3rem;
  cursor: pointer;

  .logout-icon {
    margin-right: 15px;
  }

  span {
    font-weight: 600;
  }
}

.has-search {
  .form-control {
    padding-left: 2.375rem;
  }

  .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
  }
}

.color-hover:hover {
  background-color: rgba(30, 30, 33, 0.5);
}

::v-deep .vsm--arrow::after {
  content: "\27A7" !important;
}
</style>
